import React from 'react'
import { Modal } from 'antd'
import { connect } from 'react-redux'
import SlidingPane from 'react-sliding-pane'
import classNames from 'classnames'
import removeIcon from '@assets/images/v2-dashboard/remove.svg'
import customLanguageTexts from '../../../language'
import { getTimestampAsFullHumanDate } from '../../../helpers'

const mapStateToProps = ({ settings: { visibleModalID }, apps, settings }) => ({ visibleModalID, apps, settings })

@connect(mapStateToProps)
class ModalSubscriptionCancelledEndOfTerm extends React.Component {

  handleCancel = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  render() {
    const { visibleModalID, apps, settings } = this.props
    const modalID = 'subscriptionCancelledEndOfTerm'
    const visible = modalID === visibleModalID



    return (
      <div>
        {!settings.isMobileXSView ? (
          <Modal
            className="custom__success__modal"
            title={<div>{customLanguageTexts.SUBSCRIPTION_CANCELLATION_END_OF_TERM_MODAL_TITLE}</div>}
            open={visible}
            onCancel={this.handleCancel}
            maskClosable={false}
            footer={false}
          >
            <div className="p-0">
              <div className="">
                {customLanguageTexts.SUBSCRIPTION_CANCELLATION_END_OF_TERM_MODAL_DESCRIPTION}
                <b>{getTimestampAsFullHumanDate(apps.active.cancelsAt)}</b> <br />
                {customLanguageTexts.SUBSCRIPTION_CANCELLATION_END_OF_TERM_MODAL_NOTE}
                <i className="fe fe-smile ml-2" />
              </div>
            </div>
          </Modal>
        ) : (
          <SlidingPane
            isOpen={visible}
            onRequestClose={this.handleCancel}
            className={classNames('custom__extension__slider', 'successSubcription')}
            width="100%"
            from="bottom"
            title={<div>{customLanguageTexts.SUBSCRIPTION_CANCELLATION_END_OF_TERM_MODAL_TITLE}</div>}
            closeIcon={
              <img
                src={removeIcon}
                className="closeSuccessSub"
                alt="close"
              />
            }
          >
            <div className="p-0">
              <div className="">
                {customLanguageTexts.SUBSCRIPTION_CANCELLATION_END_OF_TERM_MODAL_DESCRIPTION}
                <b>{getTimestampAsFullHumanDate(apps.active.cancelsAt)}</b> <br />
                {customLanguageTexts.SUBSCRIPTION_CANCELLATION_END_OF_TERM_MODAL_NOTE}
                <i className="fe fe-smile ml-2" />
              </div>
            </div>
          </SlidingPane>
        )}
      </div>
    )
  }
}

export default ModalSubscriptionCancelledEndOfTerm
